import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { getContent } from "../../../utils/main";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setLang } from "../../../stores/mainSlice";
import { useLocation } from "react-router-dom";

export const Header = () => {
  // Lang
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);
  const dispatch = useDispatch();
  const location = useLocation();

  const header = useRef(null);
  const toggleClass = "is-sticky";

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        if (header.current !== null) header.current.classList.add(toggleClass);
      } else {
        if (header.current !== null)
          header.current.classList.remove(toggleClass);
      }
    });
  }, []);
  return (
    <div
      className={`header w-100 ${
        location.pathname.startsWith("/welcome/section/") ? "bg-yes" : "bg-no"
      }`}
      ref={header}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col logo-wrapper">
            <Link to="/">
              <img
                src={require("./../../../assets/images/2d-logo.png")}
                alt="Logo"
              />
              <h6 className="logo-text">{getContent(content, "Name", lang)}</h6>
            </Link>
          </div>
          <div className="col-auto langs-wrapper">
            <button
              className={`clear-btn ${lang === "tm" ? "active" : ""}`}
              onClick={() => {
                localStorage.setItem("lang", "tm");
                dispatch(setLang("tm"));
              }}
            >
              TM
            </button>
            <button
              className={`clear-btn ${lang === "ru" ? "active" : ""}`}
              onClick={() => {
                localStorage.setItem("lang", "ru");
                dispatch(setLang("ru"));
              }}
            >
              RU
            </button>
            <button
              className={`clear-btn ${lang === "en" ? "active" : ""}`}
              onClick={() => {
                localStorage.setItem("lang", "en");
                dispatch(setLang("en"));
              }}
            >
              EN
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
